import { render, staticRenderFns } from "./VariableMapping.vue?vue&type=template&id=4606f561"
import script from "./VariableMapping.vue?vue&type=script&lang=js"
export * from "./VariableMapping.vue?vue&type=script&lang=js"
import style0 from "./VariableMapping.vue?vue&type=style&index=0&id=4606f561&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports